<template>
  <div class="card">
    <div class="card-header">
      <div class="utils__title">
        <strong>Blog - Tagy - Upravit <span class="utils__link--underlined text-primary">#{{ this.id }}</span></strong>
      </div>
      <action-tools :router-options="routerOptions"></action-tools>
    </div>
    <div class="card-body">
      <div class="table-operations">
        <language-tab></language-tab>
      </div>
      <a-form :form="form" @submit="handleSubmit">
        <a-form-item
        label="Název"
          :validate-status="nameError() ? 'error' : ''"
          :help="nameError() || ''"
        >
          <a-input placeholder="Název" v-decorator="['bte_name', {rules: [{max: 50, message: 'Název nemůže být delší než 50 znaků'}, {required: true, message: 'Název musí být vyplněn!'}]}]"/>
        </a-form-item>
        <div class="form-actions">
          <a-button html-type="submit" type="primary" :disabled="loading || hasErrors(form.getFieldsError())">Upravit</a-button>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script>
import LanguageTab from '@/components/MyComponents/LanguageTab'
import ActionTools from '@/components/MyComponents/ActionTools'
import { hasErrors } from '../../../../services/forms'

export default {
  components: { ActionTools, LanguageTab },
  data: function () {
    return {
      hasErrors,
      loading: false,
      routerOptions: [
        {
          icon: 'bars',
          theme: 'outlined',
          to: '/blog/tag',
          title: 'Seznam',
        },
      ],
      item: {
        tags: [],
      },
      form: this.$form.createForm(this),
      id: this.$route.params.id,
      loaded: [],
    }
  },
  computed: {
    language: function () {
      return this.$store.getters['language/active']
    },
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault()
      this.handleChange(this.language)
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          this.$store.dispatch('blogTag/put', { id: this.id, item: this.item.tags.filter(x => x.bte_name.trim().length > 0) })
            .catch(() => {})
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    handleChange(oldLanguage) {
      const foundObj = { tag: false }
      const newObj = {
        tag: {
          lge_id: oldLanguage,
          bte_name: this.form.getFieldValue('bte_name'),
        },
      }
      this.item.tags.some((value, key) => {
        if (value.lge_id === oldLanguage) {
          this.item.tags[key] = newObj.tag
          foundObj.tag = true
          return true
        }
      })
      if (!foundObj.tag) {
        this.item.tags.push(newObj.tag)
      }
    },
    handleInit() {
      this.$store.dispatch('blogTag/getOne', this.id)
        .then(() => {
          this.item.tags.push(this.$store.getters['blogTag/currentLanguageDetail'])
          this.form.setFieldsValue({
            bte_name: this.item.tags.find(x => x.lge_id === this.$store.getters['language/active']).bte_name,
          })
          this.form.validateFields()
        })
        .catch(() => {})
        .finally(() => {
          this.loaded.push(this.language)
        })
    },
    nameError() {
      const { getFieldError, isFieldTouched } = this.form
      return isFieldTouched('bte_name') && getFieldError('bte_name')
    },
    refreshComponent(id) {
      this.id = id
      this.item = {
        tags: [],
      }
      this.loaded = []
    },
  },
  created() {
    if (this.language !== null && !this.loaded.includes(this.language)) {
      this.handleInit()
    }
  },
  watch: {
    language(newValue, oldValue) {
      if (oldValue !== null && this.loaded.includes(oldValue)) {
        this.handleChange(oldValue)
      }
      if (!this.loaded.includes(this.language)) {
        this.handleInit()
      } else {
        const foundObj = this.item.tags.find(x => x.lge_id === newValue)
        this.form.setFieldsValue({
          bte_name: foundObj === undefined ? '' : foundObj.bte_name,
        })
        this.form.validateFields()
      }
    },
    '$route.params.id'(newId, oldId) {
      this.refreshComponent(newId)
      if (this.language !== null) {
        this.handleInit()
      }
    },
  },
}
</script>
